// extracted by mini-css-extract-plugin
export default {"main_container":"Social_main_container__AgbVu"};